/* global $ */
import React, { useState, useEffect, useRef } from 'react';
import axiosInstance from "../axiosInstance";
import Swal from "sweetalert2";
import { useNavigate, useLocation } from "react-router-dom";
import Footer from '../components/Footer';

function Addleads() {
    const navigate = useNavigate();
    const location = useLocation();
    
    // Check if we're editing a lead
    const isEditMode = location.state?.isEdit || false;
    const leadToEdit = location.state?.lead || null;
    
    const [cities, setCities] = useState([]);
    const [states, setStates] = useState([]);
    const [countries, setCountries] = useState([]);
    const [users, setUsers] = useState([]); // For Lead Owner dropdown
    const [filteredStates, setFilteredStates] = useState([]);
    const [filteredCities, setFilteredCities] = useState([]);
    const [isSaving, setIsSaving] = useState(false);
    const [isSaved, setIsSaved] = useState(false);
    const [loading, setLoading] = useState(true);
    const [newRecord, setNewRecord] = useState({
        company_name: "",
        phone: "",
        alternate_phone: "",
        whatsapp_no: "",
        email: "",
        industry: "",
        sub_industry: "",
        address_line1: "",
        address_line2: "",
        country_id: "",
        state_id: "",
        city_id: "",
        status: "",
        source: "",
        lead_owner: "",
        notes: "",
    });

    // Populate form with lead data if editing
    useEffect(() => {
        if (isEditMode && leadToEdit) {
            console.log("Editdata: ", leadToEdit)
            setNewRecord({
                company_name: leadToEdit.company_name || "",
                phone: leadToEdit.phone || "",
                alternate_phone: leadToEdit.alternate_phone || "",
                whatsapp_no: leadToEdit.whatsapp_no || "",
                email: leadToEdit.email || "",
                industry: leadToEdit.industry || "",
                sub_industry: leadToEdit.sub_industry || "",
                address_line1: leadToEdit.address_line1 || "",
                address_line2: leadToEdit.address_line2 || "",
                country_id: leadToEdit.country_id || "",
                state_id: leadToEdit.state_id || "",
                city_id: leadToEdit.city_id || "",
                status: leadToEdit.status || "",
                source: leadToEdit.source || "",
                lead_owner: leadToEdit.lead_owner || "",
                notes: leadToEdit.notes || "",
            });
        }
    }, [isEditMode, leadToEdit]);

    const [errors, setErrors] = useState({
        company_name: "",
        phone: "",
        email: "",
        industry: "",
        sub_industry: "",
        address_line1: "",
        country_id: "",
        state_id: "",
        city_id: "",
        status: "",
        source: "",
        lead_owner: "",
        notes: "",
    });

    const validateForm = () => {
        let formErrors = {};
        const phoneRegex = /^\d{10}$/;

        if (!newRecord.company_name) {
            formErrors.company_name = "Lead Name is required";
        }

        if (!newRecord.phone) {
            formErrors.phone = "Phone is required";
        } else if (!phoneRegex.test(newRecord.phone)) {
            formErrors.phone = 'Please enter a valid 10-digit phone number';
        }

        if (!newRecord.industry) {
            formErrors.industry = "Industry is required";
        }

        if (!newRecord.sub_industry) {
            formErrors.sub_industry = "Sub Industry is required";
        }

        if (!newRecord.address_line1) {
            formErrors.address_line1 = "Address Line 1 is required";
        }

        if (!newRecord.country_id) {
            formErrors.country_id = "Country is required";
        }

        if (!newRecord.state_id) {
            formErrors.state_id = "State is required";
        }

        if (!newRecord.city_id) {
            formErrors.city_id = "City is required";
        }

        if (!newRecord.status) {
            formErrors.status = "Status is required";
        }

        if (!newRecord.source) {
            formErrors.source = "Source is required";
        }

        if (!newRecord.lead_owner) {
            formErrors.lead_owner = "Lead Owner is required";
        }

        if (!newRecord.whatsapp_no) {
            formErrors.whatsapp_no = "Whatsapp Number is required";
        }

        if (Object.keys(formErrors).length > 0) {
            setErrors(formErrors);
            return false;
        }

        return true;
    };

    const select2InitRef = useRef(false);

    // Initialize Select2 when data is loaded
    useEffect(() => {
        if (countries.length > 0 && states.length > 0 && users.length > 0) {
            setTimeout(() => {
                try {
                    // Check if jQuery and Select2 are available
                    if (typeof $ !== 'undefined' && $.fn.select2) {
                        // Destroy existing Select2 instances first
                        $(".select2").each(function () {
                            if ($(this).hasClass('select2-hidden-accessible')) {
                                $(this).select2('destroy');
                            }
                        });

                        // Initialize Select2 for all select elements
                        $(".select2").select2({
                            width: '100%',
                            placeholder: function() {
                                return $(this).find('option:first').text();
                            }
                        });

                        // Handle Select2 change events
                        $('.select2').off('select2:select').on('select2:select', function (e) {
                            const selectElement = e.target;
                            const event = new Event('change', { bubbles: true });
                            selectElement.dispatchEvent(event);
                        });

                        console.log("Select2 initialized successfully");
                        select2InitRef.current = true;
                    } else {
                        console.warn("jQuery or Select2 not available");
                    }
                } catch (error) {
                    console.error("Error initializing Select2:", error);
                }
            }, 500);
        }

        return () => {
            try {
                if (typeof $ !== 'undefined' && $.fn.select2) {
                    $('.select2').off('select2:select');
                    $(".select2").each(function () {
                        if ($(this).hasClass('select2-hidden-accessible')) {
                            $(this).select2('destroy');
                        }
                    });
                }
            } catch (error) {
                console.error("Error cleaning up Select2:", error);
            }
        };
    }, [countries, states, users]);

    // Reinitialize Select2 when filtered data changes
    useEffect(() => {
        if (select2InitRef.current && typeof $ !== 'undefined' && $.fn.select2) {
            setTimeout(() => {
                try {
                    // Reinitialize state dropdown
                    const $stateSelect = $('select[name="state_id"]');
                    if ($stateSelect.length) {
                        if ($stateSelect.hasClass('select2-hidden-accessible')) {
                            $stateSelect.select2('destroy');
                        }
                        $stateSelect.select2({
                            width: '100%',
                            placeholder: 'Select State'
                        });
                    }
                } catch (error) {
                    console.error("Error reinitializing state Select2:", error);
                }
            }, 100);
        }
    }, [filteredStates]);

    // Reinitialize Select2 when cities change
    useEffect(() => {
        if (select2InitRef.current && typeof $ !== 'undefined' && $.fn.select2) {
            setTimeout(() => {
                try {
                    // Reinitialize city dropdown
                    const $citySelect = $('select[name="city_id"]');
                    if ($citySelect.length) {
                        if ($citySelect.hasClass('select2-hidden-accessible')) {
                            $citySelect.select2('destroy');
                        }
                        $citySelect.select2({
                            width: '100%',
                            placeholder: 'Select City'
                        });
                    }
                } catch (error) {
                    console.error("Error reinitializing city Select2:", error);
                }
            }, 100);
        }
    }, [filteredCities]);

    // Reinitialize Select2 for edit mode after data is populated
    useEffect(() => {
        if (isEditMode && leadToEdit && select2InitRef.current && filteredStates.length > 0 && filteredCities.length > 0) {
            setTimeout(() => {
                try {
                    // Reinitialize all select2 dropdowns with current values
                    $('.select2').each(function() {
                        const $this = $(this);
                        if ($this.hasClass('select2-hidden-accessible')) {
                            $this.select2('destroy');
                        }
                        $this.select2({
                            width: '100%',
                            placeholder: $this.find('option:first').text()
                        });
                    });
                } catch (error) {
                    console.error("Error reinitializing Select2 for edit mode:", error);
                }
            }, 200);
        }
    }, [isEditMode, leadToEdit, filteredStates, filteredCities]);

    // Filter states based on selected country
    useEffect(() => {
        if (newRecord.country_id && states.length > 0) {
            const filtered = states.filter(state => state.country_id == newRecord.country_id);
            setFilteredStates(filtered);

            // Only reset state and city if this is not initial load with edit data
            if (!isEditMode || !leadToEdit) {
                // Reset state and city selection when country changes (only for new records)
                if (newRecord.state_id) {
                    const isStateValid = filtered.some(state => state.id == newRecord.state_id);
                    if (!isStateValid) {
                        setNewRecord(prev => ({ ...prev, state_id: "", city_id: "" }));
                        setFilteredCities([]);
                    }
                }
            }
        } else {
            setFilteredStates([]);
            if (!isEditMode || !leadToEdit) {
                setFilteredCities([]);
                setNewRecord(prev => ({ ...prev, state_id: "", city_id: "" }));
            }
        }
    }, [newRecord.country_id, states, isEditMode, leadToEdit]);

    // Filter cities based on selected state
    useEffect(() => {
        if (newRecord.state_id && cities.length > 0) {
            const filtered = cities.filter(city => city.state_id == newRecord.state_id);
            setFilteredCities(filtered);

            // Only reset city if this is not initial load with edit data
            if (!isEditMode || !leadToEdit) {
                // Reset city selection when state changes (only for new records)
                if (newRecord.city_id) {
                    const isCityValid = filtered.some(city => city.id == newRecord.city_id);
                    if (!isCityValid) {
                        setNewRecord(prev => ({ ...prev, city_id: "" }));
                    }
                }
            }
        } else {
            setFilteredCities([]);
            if (!isEditMode || !leadToEdit) {
                setNewRecord(prev => ({ ...prev, city_id: "" }));
            }
        }
    }, [newRecord.state_id, cities, isEditMode, leadToEdit]);

    // Initialize filtered states and cities when data is loaded and we're in edit mode
    useEffect(() => {
        if (isEditMode && leadToEdit && states.length > 0 && cities.length > 0 && newRecord.country_id) {
            // Filter states for the selected country
            const filtered = states.filter(state => state.country_id == newRecord.country_id);
            setFilteredStates(filtered);

            // Filter cities for the selected state
            if (newRecord.state_id) {
                const filteredCities = cities.filter(city => city.state_id == newRecord.state_id);
                setFilteredCities(filteredCities);
            }
        }
    }, [isEditMode, leadToEdit, states, cities, newRecord.country_id, newRecord.state_id]);

    // Fetch Cities
    const fetchCities = async () => {
        try {
            const response = await axiosInstance.get("/cities/all");
            setCities(response.data.data);
            console.log("Cities", response.data.data);
        } catch (error) {
            console.error("Error fetching Cities:", error);
        }
    };

    // Fetch States
    const fetchStates = async () => {
        try {
            const response = await axiosInstance.get("/state/withcountry");
            setStates(response.data.data);
            console.log("States", response.data.data);
        } catch (error) {
            console.error("Error fetching States:", error);
        }
    };

    // Fetch Countries
    const fetchCountries = async () => {
        try {
            const response = await axiosInstance.get("/country/");
            setCountries(response.data.data);
            console.log("Countries", response.data.data);
        } catch (error) {
            console.error("Error fetching Countries:", error);
        }
    };

    // Fetch Users for Lead Owner dropdown
    const fetchUsers = async () => {
        try {
            const response = await axiosInstance.get("/users/");
            setUsers(response.data.data);
            console.log("Users", response.data.data);
        } catch (error) {
            console.error("Error fetching Users:", error);
        }
    };

    // Fetch all data on component mount
    useEffect(() => {
        const loadData = async () => {
            setLoading(true);
            try {
                await Promise.all([
                    fetchCities(),
                    fetchStates(),
                    fetchCountries(),
                    fetchUsers()
                ]);
            } catch (error) {
                console.error("Error loading data:", error);
            } finally {
                setLoading(false);
            }
        };
        
        loadData();
    }, []);

    // Handle Form Input Change
    const handleChange = (e) => {
        const { name, value } = e.target;
        setNewRecord({ ...newRecord, [name]: value });
        
        // Clear error when user starts typing
        if (errors[name]) {
            setErrors(prev => ({ ...prev, [name]: "" }));
        }
    };

    const saveLead = async (event) => {
        event.preventDefault();

        if (isSaving || isSaved) return;

        if (validateForm()) {
            setIsSaving(true);
            setLoading(true);
            setErrors({});

            try {
                const created_by = localStorage.getItem('user_id');

                const updatedFormData = {
                    ...newRecord,
                    created_by: created_by,
                };
                
                console.log("Lead data to save:", updatedFormData);

                let formResponse;
                if (isEditMode && leadToEdit) {
                    // Update existing lead
                    formResponse = await axiosInstance.put(`/leads/${leadToEdit.id}`, updatedFormData);
                    console.log("Lead updated:", formResponse.data);
                    Swal.fire('Updated!', 'Lead updated successfully', 'success');
                } else {
                    // Create new lead
                    formResponse = await axiosInstance.post('/leads/', updatedFormData);
                    console.log("Lead created:", formResponse.data);
                    Swal.fire('Saved!', 'Lead saved successfully', 'success');
                }

                setIsSaved(true);
                navigate("/lead", { replace: true });

            } catch (error) {
                console.error('Error saving lead:', error);
                let errorMessage = isEditMode ? 'There was an issue in updating the lead.' : 'There was an issue in saving the lead.';
                if (error.response && error.response.data && error.response.data.message) {
                    errorMessage = error.response.data.message;
                }

                Swal.fire({
                    icon: 'error',
                    title: isEditMode ? 'Error Updating Lead!' : 'Error Saving Lead!',
                    text: errorMessage,
                });
            } finally {
                setLoading(false);
                setIsSaving(false);
            }
        }
    };

    return (
        <div>
            <div className="page-wrapper">
                <div className="content container-fluid">
                    <div className="card mb-0">
                        <div className="card-body">
                            <div className="page-header">
                                <div className="content-page-header">
                                    <h5>{isEditMode ? 'Edit Lead' : 'Add Lead'}</h5>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <form onSubmit={saveLead}>
                                        <div className="form-group-item">
                                            <h5 className="form-title">Basic Details</h5>
                                            <div className="row">
                                                <div className="col-lg-4 col-md-6 col-sm-12">
                                                    <div className="input-block mb-3">
                                                        <label>Lead Name <span className="text-danger">*</span></label>
                                                        <input 
                                                            type="text" 
                                                            name="company_name" 
                                                            value={newRecord.company_name} 
                                                            onChange={handleChange} 
                                                            className="form-control" 
                                                            placeholder="Enter Lead Name" 
                                                        />
                                                        {errors.company_name && <small className="text-danger">{errors.company_name}</small>}
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 col-md-6 col-sm-12">
                                                    <div className="input-block mb-3">
                                                        <label>Phone Number <span className="text-danger">*</span></label>
                                                        <input 
                                                            type="text" 
                                                            name="phone" 
                                                            id="mobile_code" 
                                                            value={newRecord.phone} 
                                                            onChange={handleChange} 
                                                            className="form-control" 
                                                            placeholder="Enter Phone Number" 
                                                        />
                                                        {errors.phone && <small className="text-danger">{errors.phone}</small>}
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 col-md-6 col-sm-12">
                                                    <div className="input-block mb-3">
                                                        <label>Alternate Phone</label>
                                                        <input 
                                                            type="text" 
                                                            name="alternate_phone" 
                                                            id="mobile_codes" 
                                                            value={newRecord.alternate_phone} 
                                                            onChange={handleChange} 
                                                            className="form-control" 
                                                            placeholder="Alternate Phone Number" 
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 col-md-6 col-sm-12">
                                                    <div className="input-block mb-3">
                                                        <label>WhatsApp Number <span className="text-danger">*</span></label>
                                                        <input 
                                                            type="text" 
                                                            name="whatsapp_no" 
                                                            value={newRecord.whatsapp_no} 
                                                            onChange={handleChange} 
                                                            className="form-control" 
                                                            placeholder="WhatsApp Number" 
                                                        />
                                                        {errors.whatsapp_no && <small className="text-danger">{errors.whatsapp_no}</small>}
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 col-md-6 col-sm-12">
                                                    <div className="input-block mb-3">
                                                        <label>Email </label>
                                                        <input 
                                                            type="email" 
                                                            name="email" 
                                                            value={newRecord.email} 
                                                            onChange={handleChange} 
                                                            className="form-control" 
                                                            placeholder="Enter Email Address" 
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 col-md-6 col-sm-12">
                                                    <div className="input-block mb-3">
                                                        <label>Industry <span className="text-danger">*</span></label>
                                                        <select
                                                            className="select2"
                                                            name="industry"
                                                            value={newRecord.industry}
                                                            onChange={handleChange}
                                                        >
                                                            <option value="">Select Industry</option>
                                                            <option value="Accounting">Accounting</option>
                                                            <option value="Advertising / Marketing">Advertising / Marketing</option>
                                                            <option value="Aerospace / Aviation">Aerospace / Aviation</option>
                                                            <option value="Agriculture">Agriculture</option>
                                                            <option value="Apparel / Fashion">Apparel / Fashion</option>
                                                            <option value="Automotive">Automotive</option>
                                                            <option value="Banking / Financial Services">Banking / Financial Services</option>
                                                            <option value="Biotechnology">Biotechnology</option>
                                                            <option value="Chemicals">Chemicals</option>
                                                            <option value="Construction">Construction</option>
                                                            <option value="Consulting">Consulting</option>
                                                            <option value="Consumer Goods">Consumer Goods</option>
                                                            <option value="Defense & Security">Defense & Security</option>
                                                            <option value="Education">Education</option>
                                                            <option value="Electronics">Electronics</option>
                                                            <option value="Energy / Utilities / Oil & Gas">Energy / Utilities / Oil & Gas</option>
                                                            <option value="Engineering">Engineering</option>
                                                            <option value="Entertainment / Media">Entertainment / Media</option>
                                                            <option value="Environmental Services">Environmental Services</option>
                                                            <option value="Food & Beverages">Food & Beverages</option>
                                                            <option value="Government / Public Sector">Government / Public Sector</option>
                                                            <option value="Healthcare / Medical / Pharmaceuticals">Healthcare / Medical / Pharmaceuticals</option>
                                                            <option value="Hospitality / Travel / Tourism">Hospitality / Travel / Tourism</option>
                                                            <option value="Information Technology / Software">Information Technology / Software</option>
                                                            <option value="Insurance">Insurance</option>
                                                            <option value="Legal / Law">Legal / Law</option>
                                                            <option value="Logistics / Supply Chain">Logistics / Supply Chain</option>
                                                            <option value="Manufacturing">Manufacturing</option>
                                                            <option value="Marine / Shipping">Marine / Shipping</option>
                                                            <option value="Mining & Metals">Mining & Metals</option>
                                                            <option value="Non-Profit / NGO">Non-Profit / NGO</option>
                                                            <option value="Printing / Publishing">Printing / Publishing</option>
                                                            <option value="Real Estate">Real Estate</option>
                                                            <option value="Retail / E-commerce">Retail / E-commerce</option>
                                                            <option value="Telecommunications">Telecommunications</option>
                                                            <option value="Textiles">Textiles</option>
                                                            <option value="Transportation">Transportation</option>
                                                            <option value="Venture Capital / Private Equity">Venture Capital / Private Equity</option>
                                                            <option value="Warehousing / Distribution">Warehousing / Distribution</option>
                                                        </select>
                                                        {errors.industry && <small className="text-danger">{errors.industry}</small>}
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 col-md-6 col-sm-12">
                                                    <div className="input-block mb-3">
                                                        <label>Sub Industry <span className="text-danger">*</span></label>
                                                        <input 
                                                            type="text" 
                                                            name="sub_industry" 
                                                            value={newRecord.sub_industry} 
                                                            onChange={handleChange} 
                                                            className="form-control" 
                                                            placeholder="Enter Sub Industry" 
                                                        />
                                                        {errors.sub_industry && <small className="text-danger">{errors.sub_industry}</small>}
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 col-md-6 col-sm-12">
                                                    <div className="input-block mb-3">
                                                        <label>Address Line 1 <span className="text-danger">*</span></label>
                                                        <input 
                                                            type="text" 
                                                            name="address_line1" 
                                                            value={newRecord.address_line1} 
                                                            onChange={handleChange} 
                                                            className="form-control" 
                                                            placeholder="Enter Address Line 1" 
                                                        />
                                                        {errors.address_line1 && <small className="text-danger">{errors.address_line1}</small>}
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 col-md-6 col-sm-12">
                                                    <div className="input-block mb-3">
                                                        <label>Address Line 2</label>
                                                        <input 
                                                            type="text" 
                                                            name="address_line2" 
                                                            value={newRecord.address_line2} 
                                                            onChange={handleChange} 
                                                            className="form-control" 
                                                            placeholder="Enter Address Line 2" 
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 col-md-6 col-sm-12">
                                                    <div className="input-block mb-3">
                                                        <label>Country <span className="text-danger">*</span></label>
                                                        <select
                                                            className="select2"
                                                            name="country_id"
                                                            value={newRecord.country_id}
                                                            onChange={handleChange}
                                                        >
                                                            <option value="">Select Country</option>
                                                            {countries.map((country) => (
                                                                <option key={country.id} value={country.id}>
                                                                    {country.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        {errors.country_id && <small className="text-danger">{errors.country_id}</small>}
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 col-md-6 col-sm-12">
                                                    <div className="input-block mb-3">
                                                        <label>State <span className="text-danger">*</span></label>
                                                        <select
                                                            className="select2"
                                                            name="state_id"
                                                            value={newRecord.state_id}
                                                            onChange={handleChange}
                                                            disabled={!newRecord.country_id}
                                                        >
                                                            <option value="">Select State</option>
                                                            {filteredStates.map((state) => (
                                                                <option key={state.id} value={state.id}>
                                                                    {state.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        {errors.state_id && <small className="text-danger">{errors.state_id}</small>}
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 col-md-6 col-sm-12">
                                                    <div className="input-block mb-3">
                                                        <label>City <span className="text-danger">*</span></label>
                                                        <select
                                                            className="select2"
                                                            name="city_id"
                                                            value={newRecord.city_id}
                                                            onChange={handleChange}
                                                            disabled={!newRecord.state_id}
                                                        >
                                                            <option value="">Select City</option>
                                                            {filteredCities.map((city) => (
                                                                <option key={city.id} value={city.id}>
                                                                    {city.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        {errors.city_id && <small className="text-danger">{errors.city_id}</small>}
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 col-md-6 col-sm-12">
                                                    <div className="input-block mb-3">
                                                        <label>Status <span className="text-danger">*</span></label>
                                                        <select
                                                            className="select2"
                                                            name="status"
                                                            value={newRecord.status}
                                                            onChange={handleChange}
                                                        >
                                                            <option value="">Select Status</option>
                                                            <option value="New">New</option>
                                                            <option value="Secure Lead">Secure Lead</option>
                                                            <option value="Profile Shared">Profile Shared</option>
                                                            <option value="Proposal Sent">Proposal Sent</option>
                                                            <option value="Won">Won</option>
                                                            <option value="Lost">Lost</option>
                                                        </select>
                                                        {errors.status && <small className="text-danger">{errors.status}</small>}
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 col-md-6 col-sm-12">
                                                    <div className="input-block mb-3">
                                                        <label>Source <span className="text-danger">*</span></label>
                                                        <select
                                                            className="select2"
                                                            name="source"
                                                            value={newRecord.source}
                                                            onChange={handleChange}
                                                        >
                                                            <option value="">Select Source</option>
                                                            <option value="Google Scraping">Google Scraping</option>
                                                            <option value="Website Enquiry">Website Enquiry</option>
                                                            <option value="Social Media">Social Media</option>
                                                            <option value="Referral">Referral</option>
                                                            <option value="Paid Ads">Paid Ads</option>
                                                            <option value="Trade Show">Trade Show</option>
                                                            <option value="Events">Events</option>
                                                            <option value="Email Campaign">Email Campaign</option>
                                                            <option value="Direct">Direct</option>
                                                            <option value="Other">Other</option>
                                                        </select>
                                                        {errors.source && <small className="text-danger">{errors.source}</small>}
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 col-md-6 col-sm-12">
                                                    <div className="input-block mb-3">
                                                        <label>Lead Owner <span className="text-danger">*</span></label>
                                                        <select
                                                            className="select2"
                                                            name="lead_owner"
                                                            value={newRecord.lead_owner}
                                                            onChange={handleChange}
                                                        >
                                                            <option value="">Select Lead Owner</option>
                                                            {users.map((user) => (
                                                                <option key={user.id} value={user.id}>
                                                                    {user.user_name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        {errors.lead_owner && <small className="text-danger">{errors.lead_owner}</small>}
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 col-md-6 col-sm-12">
                                                    <div className="input-block mb-3">
                                                        <label>Notes </label>
                                                        <textarea 
                                                            name="notes" 
                                                            value={newRecord.notes} 
                                                            onChange={handleChange} 
                                                            className="form-control" 
                                                            placeholder="Enter Notes"
                                                            rows="3"
                                                        />                                                        
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="add-customer-btns text-end">
                                            <a href="/lead" className="btn customer-btn-cancel">Cancel</a>
                                            <button 
                                                type="submit" 
                                                className="btn customer-btn-save" 
                                                disabled={isSaving || isSaved}
                                            >
                                                {isSaved ? (isEditMode ? 'Lead Updated' : 'Lead Saved') : 
                                                 isSaving ? (isEditMode ? 'Updating...' : 'Saving...') : 
                                                 (isEditMode ? 'Update Lead' : 'Save Lead')}
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        </div>
    )
}

export default Addleads